export const TENANT_ADMIN_ROLE = 'TENANT_ADMIN';

/** BR-IDT-17 — workshop admin may mutate the global city catalog. */
export function canMutateGeoCities(roles: readonly string[]): boolean {
  return roles.includes(TENANT_ADMIN_ROLE);
}
